enum SimStatus {
  SIM_UNSET = 'SIM_UNSET', // Do not use, needed because of proto3 limitations
  SIM_ACTIVATED = 'SIM_ACTIVATED',
  SIM_PENDING = 'SIM_PENDING',
  SIM_DEACTIVATED = 'SIM_DEACTIVATED',
  SIM_FAILED_TO_TERMINATE = 'SIM_FAILED_TO_TERMINATE',
}

export { SimStatus as WPSimStatus };
